import { z } from "zod";
/** Channels a chat request can originate from. */
export const chatChannelSchema = z.enum(["web", "slack", "voice", "api"]);
/** Request body for POST /agents/chat */
export const chatRequestSchema = z.object({
    agent_id: z.string().min(1),
    message: z.string().min(1),
    thread_id: z.string().min(1).optional(),
    channel: chatChannelSchema.optional(),
    channel_metadata: z.record(z.string(), z.unknown()).optional(),
    org_id: z.string().uuid().optional(),
    /** Attacker-controlled — treat as untrusted input server-side. Max 4KB. */
    widget_context: z
        .record(z.string(), z.unknown())
        .optional()
        .refine((ctx) => ctx === undefined || JSON.stringify(ctx).length <= 4096, "widget_context must not exceed 4KB"),
});
/** Request body for POST /agents/voice-session */
export const voiceSessionRequestSchema = z.object({
    agent_id: z.string().min(1),
    org_id: z.string().uuid(),
    /** Optional hint at the thread to continue; ownership is re-validated server-side. */
    thread_id: z.string().min(1).optional(),
    /** Attacker-controlled — treat as untrusted input server-side. Max 4KB. */
    widget_context: z
        .record(z.string(), z.unknown())
        .optional()
        .refine((ctx) => ctx === undefined || JSON.stringify(ctx).length <= 4096, "widget_context must not exceed 4KB"),
});
/** Response body for POST /agents/voice-session */
export const voiceSessionResponseSchema = z.object({
    livekit_url: z.string().url(),
    token: z.string().min(1),
    room_name: z.string().min(1),
    thread_id: z.string().uuid(),
    agent_id: z.string(),
    end_user_identity: z.string(),
});
export const threadSchema = z.object({
    id: z.string(),
    title: z.string().optional().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const threadHistoryMessageSchema = z.object({
    id: z.string(),
    type: z.string(),
    role: z.string(),
    content: z.string(),
    timestamp: z.string(),
    /** Modality the turn was delivered on. Pre-modality messages default to text. */
    modality: z.enum(["text", "voice"]).default("text"),
});
/** Route params for GET /agents/public-config/:orgId/:agentId */
export const publicAgentConfigParamsSchema = z.object({
    orgId: z.string().uuid(),
    agentId: z.string().min(1),
});
/** Response shape for GET /agents/public-config/:orgId/:agentId */
export const publicAgentConfigSchema = z.object({
    agent_id: z.string(),
    display_name: z.string(),
    org_id: z.string().uuid(),
});
